<template>
	<v-dialog v-model="showDialog" scrollable width="600px">
		<v-card>
			<v-card-title>
				{{ editedGroup.Id ? 'Rename Group' : 'Add Group' }}
			</v-card-title>

			<v-card-text>
				<v-text-field
					v-model="editedGroup.Name"
					hide-details
					label="Group name"
				/>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn text outlined @click="showDialog = false"> Close </v-btn>
				<v-btn color="primary" @click="saveGroup"> Save </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'AddEditGroupDialog',
	props: {
		dialog: Boolean,
		editedGroup: Object,
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog;
			},
			set() {
				this.$emit('closeDialog');
			},
		},
	},
	methods: {
		saveGroup() {
			this.$emit('saveGroup', this.editedGroup);
		},
	},
};
</script>

<style scoped></style>
